export const objNullsToStrings = <T extends object>(obj: T): T => {
  const newObj = Object.entries(obj).reduce((result, [key, value]) => {
    (result as any)[key] = value === null ? "" : value;
    return result;
  }, {} as T);
  return newObj;
};
